import { useFormik } from 'formik';
import React from 'react';
import Select from 'react-select';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AddAuthUser, getUsers } from '../../../../store/NTX/Security/usersSlice';
import { formAddUserSchema } from '../../../ValidationForm/validationSchema';
import useLookupPeopleCode from '../../../../hooks/Lookups/use-Get_PEOPLE_CODE';
import Reference from './Reference';
import Loading from '../../../../components/Shared/Loader/Loading';

function AddUser() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  //
  const { OptionsPeopleCode, loading, error } = useLookupPeopleCode();
  const UserTypes = [{ label: t('employee'), value: 'EMPLOYEE' }, ...OptionsPeopleCode];
  const { Users } = useSelector(state => state.Users);
  const existingUserNames = Users?.map(m => m.usersName); // قائمة بأسماء المستخدمين الحالية

 
  

  ///
  const formik = useFormik({
    initialValues: {
      usersName: '',
      emailAddress: '',
      usersMobile: '',
      description: '',
      userType: 'EMPLOYEE',
      referenceId: '',
      isActive: false,
      startDate: '',
      endDate: '',
      businessGroupId: ''
    },

    validationSchema: formAddUserSchema(t, existingUserNames),

    onSubmit: values => {
      dispatch(
        AddAuthUser({
          usersName: values.usersName,
          emailAddress: values.emailAddress,
          usersMobile: values.usersMobile,
          description: values.description,
          userType: values.userType,
          referenceId: values.referenceId,
          // isActive: values.isActive,
          isActive: true, // في الإضافة تفعيـــل افتراضي
          startDate: values.startDate,
          endDate: values.endDate || null
          // businessGroupId: null,
          //
        })
      )
        .unwrap()
        .then(res => {
          debugger;
          CustomAlert({ action: 'Add' });
          document.getElementById('closeModalUser')?.click();
          formik?.resetForm();
          dispatch(getUsers());
        })
        .catch(error => {
          // debugger;
          if (error?.succeeded === false) {
            CustomAlert({ action: 'info', msg: 'اسم المستحدم موجود مسبقاً' });
            formik.setSubmitting(false);
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error' });
          }
        });
    }
  });

  return (
    <>
      <Loading loading={loading} error={error}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row'>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('TypeOfUser')}</label>
                <Select
                  classNamePrefix='react-select'
                  isLoading={loading}
                  isSearchable={true}
                  // isClearable
                  name='userType'
                  options={UserTypes}
                  onChange={option => {
                    formik.setFieldValue('userType', option === null ? '' : option.value);
                  }}
                  value={UserTypes.find(f => f.value === formik.values.userType)}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <Reference formik={formik} />
                {formik.errors.referenceId && formik.touched.referenceId && (
                  <div style={{ color: 'red' }}>{formik.errors.referenceId}</div>
                )}
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('UserName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='usersName'
                  onChange={formik.handleChange}
                  value={formik.values.usersName}
                  isInvalid={formik.touched.usersName && formik.errors.usersName}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.usersName}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Email')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='emailAddress'
                  onChange={formik.handleChange}
                  value={formik.values.emailAddress}
                  isInvalid={formik.touched.emailAddress && formik.errors.emailAddress}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.emailAddress}
                </Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('MobileNumber')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='usersMobile'
                  onChange={formik.handleChange}
                  value={formik.values.usersMobile}
                  isInvalid={formik.touched.usersMobile && formik.errors.usersMobile}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.usersMobile}
                </Form.Control.Feedback>
              </div>
            </div>

            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Start Date')}</label>
                <Form.Control
                  type='date'
                  className='form-control'
                  name='startDate'
                  onChange={formik.handleChange}
                  value={formik.values.startDate}
                  isInvalid={formik.touched.startDate && formik.errors.startDate}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.startDate}
                </Form.Control.Feedback>
              </div>
            </div>
            <div className='col-xl-4'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Date_TO')}</label>

                <Form.Control
                  type='date'
                  className='form-control'
                  name='endDate'
                  onChange={formik.handleChange}
                  value={formik.values.endDate}
                  isInvalid={formik.touched.endDate && formik.errors.endDate}
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.endDate}
                </Form.Control.Feedback>
              </div>
            </div>
          </div>

          <div className='col-xl-12'>
            <div className='form-group mb-3'>
              <label className='form-label'>{t('Note')}</label>
              <Form.Control
                className='form-control'
                as='textarea'
                rows={2}
                name='description'
                onChange={formik.handleChange}
                value={formik.values.description}
              />
            </div>
          </div>

          <div className='d-flex gap-2'>
            <button
              disabled={formik.isSubmitting}
              type='submit'
              className='btn btn-lg btn-theme w-100'
            >
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
              )}
              {t('Add')}
            </button>

            <button
              type='button'
              className='btn btn-lg btn-default w-100'
              data-bs-dismiss='modal'
              id='closeModalForm'
            >
              <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
            </button>
          </div>
        </Form>
      </Loading>
    </>
  );
}

export default AddUser;

// {/* <div className="col-xl-6">
//           <div className="form-group mb-3">
//             <label className="form-label">{t('EmployeeName')}</label>

//             <Select
//               classNamePrefix="react-select"
//               isLoading={loading}
//               isSearchable={true}
//               isClearable
//               name="referenceId"
//               options={dataEmployees}
//               onChange={(option) => {
//                 formik.setFieldValue('referenceId', option === null ? null : option.value);
//               }}
//               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//             />
//           </div>
//         </div> */}
